<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M2.771 15.401q.12-1.176.417-2.253a9 9 0 0 1 .84-2.03q.536-.951 1.227-1.5l-3.38.144v-1.65h4.65L6.88 9.24q-.28.242-.548.716-.268.466-.517 1.145-.242.672-.392 1.625a13 13 0 0 0-.13 2.676zm11.342 0q.119-1.176.417-2.253a9 9 0 0 1 .84-2.03q.536-.951 1.226-1.5l-3.38.144v-1.65h4.65l.355 1.127q-.28.242-.548.716-.267.466-.516 1.145a9 9 0 0 0-.393 1.625 13 13 0 0 0-.13 2.676z"
	/>
	<path
		d="M7.62 15.545a20.6 20.6 0 0 1 .638-3.453q.468-1.66 1.288-3.11.82-1.46 1.88-2.299l-5.18.22V4.375h7.125l.544 1.726q-.429.372-.84 1.097a11.6 11.6 0 0 0-.791 1.755q-.372 1.03-.601 2.49a20 20 0 0 0-.2 4.102z"
	/>
</svg>
